<template>
	<v-header title="个人中心" headerLeftStatus="true" />
	<div class="sysMain">
		<div class="sysMainBody">
			<Row>
				<Col span="24" style="text-align: center;font-size: 25px;">
				{{view.wxNickName}}
				</Col>
			</Row>
			<div style="padding: 10px;" class="ivu-m-8">
				<List>
					<ListItem @click="gorouter('/mycart')"><Text strong>
							<Icon type="md-cart" color="#ff9900" />&nbsp;&nbsp;购物车
						</Text></ListItem>
					<ListItem @click="gorouter('/orderUnPay')"><Text strong>
							<Icon type="logo-yen" color="#ff9900" />&nbsp;&nbsp;待付款订单
						</Text></ListItem>
					<ListItem @click="gorouter('/orderUnPatient')"><Text strong>
							<Icon type="md-paper" color="#ff9900" />&nbsp;&nbsp;待体检订单
						</Text></ListItem>
					<ListItem @click="gorouter('/orderComplete')"><Text strong>
							<Icon type="md-paper" color="#ff9900" />&nbsp;&nbsp;已完成订单
						</Text></ListItem>
					<ListItem @click="gorouter('/orderCancel')"><Text strong>
							<Icon type="md-paper" color="#ff9900" />&nbsp;&nbsp;已取消订单
						</Text></ListItem>
				</List>
			</div>
		</div>
	</div>
</template>

<script>
	import header from "@/components/header/index";
	import {
		getToken,
	} from '@/utils/auth'
	export default {
		name: 'center',
		data() {
			return {
				view: {
					wxNickName: "",
				},
			};
		},
		mounted() {
			this.init()
		},
		methods: {
			init() {
				var token = getToken();
				if (token) this.view.wxNickName = token.wxNickName;
			},
			gorouter(name) {
				this.$router.push(name)
			},
		},
		components: {
			"v-header": header
		}
	}
</script>
